export enum QueryKey {
  getPendencies = 'getPendencies',
}
